import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import ScheduleTimerComponent from '../../../Webinar/components/ScheduleTimerComponent/ScheduleTimerComponent'

import './WaitingRoomCountdownComponent.scss'

const WaitingRoomCountdownComponent = ({
  webinarTimeEpoch,
  isHolding,
  onLiveCountdownZero,
  isWebinarTimeInThePast,
}) => {
  return (
    <div className="waiting-room-countdown-component">
      {isHolding || isWebinarTimeInThePast ? (
        <>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Hold on" />
          </div>
          <div className="big-message">
            {isHolding ? (
              <FormattedMessage defaultMessage="Continuing shortly" />
            ) : (
              <FormattedMessage defaultMessage="Starting shortly" />
            )}
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            {/* eslint-disable-next-line formatjs/no-literal-string-in-jsx */}
            ...
          </div>
        </>
      ) : (
        <>
          <div className="starting-in">
            <FormattedMessage defaultMessage="Starting in" />
          </div>
          <ScheduleTimerComponent
            startTimeEpoch={webinarTimeEpoch}
            renderOnlyTimer
            onLiveCountdownZero={onLiveCountdownZero}
          />
        </>
      )}
    </div>
  )
}

WaitingRoomCountdownComponent.propTypes = {
  webinarTimeEpoch: PropTypes.number,
  isHolding: PropTypes.bool,
  isWebinarTimeInThePast: PropTypes.bool,
  onLiveCountdownZero: PropTypes.func,
}

export { WaitingRoomCountdownComponent }
